<template>
    <BaseTipsBlock :title="$t('tips_merchant_panel.title')" :subtitle="$t('tips_merchant_panel.subtitle')">
        <div class="gap-row-xs">
            <BaseBetaSelect :choices="availableMerchantChoices" v-model="selectedMerchant" />
        </div>


    </BaseTipsBlock>
</template>

<style scoped></style>

<script>
import BaseTipsBlock from './BaseTipsBlock.vue';
import PaymentAPI from "@/api/payment";

export default {
    components: {
        BaseTipsBlock
    },
    methods: {
        fetchInitialList () {
            PaymentAPI.getPayReceivers(this.$store.state.cafe._id)
                .then((data) => {
                    this.available_pay_receivers = data.pay_receivers;
                })
                .catch((error) => {
                    alert(error);
                });
        },
    },
    data () {
        return {
            available_pay_receivers: null,
        }
    },
    computed: {
        cafe () {
            return this.$store.state.cafe;
        },
        availableMerchantChoices () {
            if (!this.available_pay_receivers) return [];
            return this.available_pay_receivers.reduce((acc, entry) => {
                acc[entry._id] = `${entry.gateway.toUpperCase()} (${entry.company_name || 'n/a'})`;
                return acc;
            }, {});
        },
        selectedMerchant: {
            get () {
                return this.$store.state.cafe.tips.pay_receiver_id;
            },
            set (v) {
                this.$store.commit('setTipPayReceiverId', v);
                this.$store.dispatch('saveCafe');
            }
        }
    },
    mounted () {
        this.fetchInitialList();
    }
}
</script>